import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import CButton from "./CButton";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchQuestionList,
  submitQeustionnaireAnswer,
} from "../slices/questionnaireSlice";
import { toast } from "react-toastify";

const QuestionnairListPopup = ({ handleNext }) => {
  const [open, setOpen] = useState(false);
  const [questionnaireList, setQuestionnaireList] = useState([]);
  const [questionAnswerList, setQuestionAnswerList] = useState([]);
  const { questionList } = useSelector((state) => state.questionnaire);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  
  const userDetails =
    JSON.parse(localStorage.getItem("user")) ||
    JSON.parse(sessionStorage.getItem("user"));

  const dispatch = useDispatch();

  useEffect(() => {
    if (userDetails.displayWeeklyQuestions) {
      setOpen(true);
    }
  }, [userDetails.displayWeeklyQuestions]);

  useEffect(() => {
    setIsLoading(true);
    dispatch(fetchQuestionList({ limit: -1, page: 1 })).then((res) => {
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    setQuestionnaireList(questionList);
  }, [questionList]);

  const handleQuestionRadioChange = (e, question) => {
    const answerValue = e.target.value;
    const newAnswer = { question, answer: answerValue };

    setQuestionAnswerList((prev) => {
      const existingIndex = prev.findIndex((q) => q.question === question);

      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = newAnswer;
        return updated;
      }

      return [...prev, newAnswer];
    });
  };

  const handleQuestionnairSubmit = () => {
    const updatedUserDetails = {
      ...userDetails,
      displayWeeklyQuestions: false,
    };
    localStorage.setItem("user", JSON.stringify(updatedUserDetails));
    setIsSubmitLoading(true);
    dispatch(submitQeustionnaireAnswer(questionAnswerList)).then((res) => {
      toast.success(res.payload.message);
      setIsSubmitLoading(false);
      handleNext();
      setOpen(false);
    });
  };
  return (
    <Dialog open={open} fullWidth maxWidth="lg" className="question-dialog">
      <DialogContent
      // key={question._id}
      >
        {isLoading ? (
          <div className="dialog-progress">
            <CircularProgress
              sx={{
                color: "#10a790", 
              }}
            />
          </div>
        ) : (
          <>
            {questionnaireList.length > 0 &&
              questionnaireList.map((question) => (
                <>
                  <div className="question-popup-list">
                    <DialogContentText sx={{ width: "70%", minWidth: "200px" }}>
                      {question.text}
                    </DialogContentText>
                    <RadioGroup
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                      // value={value}
                      onChange={(e) =>
                        handleQuestionRadioChange(e, question._id)
                      }
                    >
                      <FormControlLabel
                        value="yes"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="no"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </div>
                </>
              ))}
          </>
        )}
      </DialogContent>
      {!isLoading && (
        <DialogActions sx={{ p: 3, display: "flex", justifyContent: "center" }}>
          {isSubmitLoading ? (
            <CButton className="btn-primary">
              <CircularProgress size={24} sx={{ position: "absolute" }} />
            </CButton>
          ) : (
            <CButton
              onClick={handleQuestionnairSubmit}
              className="btn-primary"
              disabled={
                questionnaireList.length != questionAnswerList.length ||
                questionAnswerList.length == 0
              }
            >
              Submit
            </CButton>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default QuestionnairListPopup;
